module.exports = __webpack_public_path__ + "static/media/feed2.e33ebf80.png";